import "../assets/css/contact.css"
import { useNavigate } from "react-router-dom"

export default function ThankYou() {
  const navigate = useNavigate()

  return (
    <section className="contact-form-container">
      <div className="success-message">
        <svg className="success-icon" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="24" fill="#A7F3D0"/>
          <path d="M14 25L21 32L34 19" stroke="#065F46" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <h3>Thank you!</h3>
        <p>Your message was sent successfully. We will get back to you soon.</p>
        <button
          className="submit-button"
          style={{ marginTop: "1.5rem" }}
          onClick={() => navigate("/")}
        >
          Go Back to Home
        </button>
      </div>
    </section>
  )
}